export const ADMIN_LOGIN_SUCCESS="ADMIN_LOGIN_SUCCESS";
export const ADMIN_LOGIN_REQUEST="ADMIN_LOGIN_REQUEST";
export const ADMIN_LOGIN_FAILURE="ADMIN_LOGIN_FAILURE";

export const ADMIN_PRODUCT_REQUEST="ADMIN_PRODUCT_REQUEST";
export const ADMIN_PRODUCT_SUCCESS="ADMIN_PRODUCT_SUCCESS";
export const ADMIN_PRODUCT_FAILURE="ADMIN_PRODUCT_FAILURE";

export const ADD_PRODUCT_SUCCESS="ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_REQUEST="ADD_PRODUCT_FAILURE";
export const ADD_PRODUCT_FAILURE="ADD_PRODUCT_FAILURE";
